import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'core_collections-product_based_collection_page_product_tile-click';
/**
 * Collection page product tile cta
 */ export function trackCoreCollectionsProductBasedCollectionPageProductTileClick(productBasedCollectionToken, productToken, Request_Id_string) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            productBasedCollectionToken: productBasedCollectionToken,
            productToken: productToken,
            Request_Id_string: Request_Id_string
        }
    });
}
